import {
  takeLatest,
  put,
  select,
  all,
  call,
} from 'redux-saga/effects';
import { dashboardsSelector } from '@store/tempDashboard/selectors';
import * as types from './types';
import * as configTypes from '../config/types';
import * as uiTypes from '../ui/types';
import * as requestTypes from '../request/types';
import * as dataActions from '../data/actions';
import { updateRequest } from '../utils';

function sleep(time) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), time);
  });
}

function* init() {
  yield all([
    put({ type: configTypes.INIT }),
    put({ type: uiTypes.INIT }),
    put(dataActions.initRequest()),
    put({ type: requestTypes.INIT }),
  ]);
}

function* initTempDashboard({ tempDashboardId }) {
  const dashboards = yield select(dashboardsSelector);
  const tempDashboard = dashboards[tempDashboardId];

  if (!tempDashboard || !tempDashboard.dashboard) {
    return;
  }
  yield put({ type: types.START_FETCHING });
  yield call(init);
  const { dashboard } = tempDashboard;

  try {
    const { request, config, ui } = dashboard;

    // update request time interval
    updateRequest(request);

    yield all([
      put({
        type: requestTypes.APPLY_REQUEST,
        request,
      }),
      put({
        type: configTypes.APPLY_TIMELINE_CONFIG,
        config,
      }),
      put({
        type: uiTypes.APPLY_TIMELINE_UI,
        ui,
      }),
    ]);
    yield sleep(300);
    yield put({ type: types.END_FETCHING });
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* watchInitTempDashboard() {
  yield takeLatest([
    types.INIT_TEMP_DASHBOARD,
  ], initTempDashboard);
}

export default [
  watchInitTempDashboard,
];
